export default __webpack_public_path__ + "static/media/logo.50ee21a4.svg";